import React from 'react'

import {Box, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {useScreenSize} from '@progyny/hooks/useWindowSize'

type CenteredContainerProps = {
  children: React.ReactNode
  align?: 'top' | 'center' | 'bottom'
}
type StyleProps = {
  windowHeight: number | undefined
}

const useStyles = makeStyles<StyleProps>()((theme: Theme, params) => ({
  container: {
    // height: params.windowHeight
    //   ? `calc(${params.windowHeight}px - ${theme.palette.other.constValues.appHeaderHeight}px)`
    //   : 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
  },
  wrapper: {
    padding: `${theme.palette.other.constValues.appHeaderHeight}px 0`,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xl')]: {
      height: 'auto',
      width: 'auto',
    },
  },
}))

const CenteredContainer = ({children, align}: CenteredContainerProps) => {
  const {height} = useScreenSize()
  const {classes} = useStyles({windowHeight: height})

  return (
    <Box className={classes.container}>
      <Box
        className={classes.wrapper}
        sx={{
          justifyContent:
            align === 'top'
              ? 'flex-start'
              : align === 'bottom'
                ? 'flex-end'
                : 'center',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default CenteredContainer
